var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabSpecimen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V11C0 10.45 0.195833 9.97917 0.5875 9.5875C0.979167 9.19583 1.45 9 2 9V4.725C1.7 4.54167 1.45833 4.30417 1.275 4.0125C1.09167 3.72083 1 3.38333 1 3V2C1 1.45 1.19583 0.979167 1.5875 0.5875C1.97917 0.195833 2.45 0 3 0H8C8.55 0 9.02083 0.195833 9.4125 0.5875C9.80417 0.979167 10 1.45 10 2V3C10 3.38333 9.90833 3.72083 9.725 4.0125C9.54167 4.30417 9.3 4.54167 9 4.725V9H13V4.725C12.7 4.54167 12.4583 4.30417 12.275 4.0125C12.0917 3.72083 12 3.38333 12 3V2C12 1.45 12.1958 0.979167 12.5875 0.5875C12.9792 0.195833 13.45 0 14 0H19C19.55 0 20.0208 0.195833 20.4125 0.5875C20.8042 0.979167 21 1.45 21 2V3C21 3.38333 20.9083 3.72083 20.725 4.0125C20.5417 4.30417 20.3 4.54167 20 4.725V9C20.55 9 21.0208 9.19583 21.4125 9.5875C21.8042 9.97917 22 10.45 22 11V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H2ZM15 9H18V5H15V9ZM4 9H7V5H4V9Z",
    fill: "#DE7D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabSpecimen);
export default __webpack_public_path__ + "static/media/LabSpecimen.5af8ee8710ce502b778e140de6b10188.svg";
export { ForwardRef as ReactComponent };